export default function referFriends() {
  let referBox = document.querySelector('.refer-friends__link');

  if (referBox) {
    referBox.addEventListener('click', function() {
      const currentContent = this.querySelector('.btn').innerHTML;
      const span = this.querySelector('span:first-child');
      const text = span.innerText || span.textContent;
      const tempInput = document.createElement('input');

      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);

      referBox.querySelector('.btn').innerHTML = '<span class="fa fa-check"></span> Link kopiert';

      setTimeout(function (){
        referBox.querySelector('.btn').innerHTML = currentContent;
      },500)
    });

    //scroll to refer-friends area
    setTimeout(function (){
      const header = document.querySelector('.kirinus-header');
      const target = document.querySelector('.refer-friends').closest('.big-leaf');
      let headerHeight = 104;

      if (header) {
        headerHeight = header.offsetHeight;
      }

      window.scrollTo({
        top: target.getBoundingClientRect().top - headerHeight,
        behavior: 'smooth'
      });
    }, 500);
  }
}
